import React,{ Component } from 'react';

import {
  Button,
  FormGroup,
  Input,
  FormText
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

class CampaignPriorityForm extends Component {
  constructor(props){
    super(props);

    this.state = {
      validationMessages:{},
      isShowingPopover:false
    };
  }

  componentWillMount(){
    if(this.props.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(data){
    const validationMessages = {};

    if(!data.name || data.name.trim().length === 0){
      validationMessages['campaignName'] = 'Name is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    const { validationMessages} = this.state;
    return (
      <Form
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target='CampaignPriorityInput'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Experience Name'
        >
          <p>
            Sorting priority of the experience in the feed
          </p>
        </TutorialPopover>
        <FormGroup>
          <Input
            id='CampaignPriorityInput'
            type='select'
            name='priority'
            defaultValue={this.props.priority}
            onChange={(e) => this.setState({selectedValue:e.target.value})}
          >
            <option key={1} value={1}>1</option>
            <option key={2} value={2}>2</option>
            <option key={3} value={3}>3</option>
            <option key={4} value={4}>4</option>
            <option key={5} value={5}>5</option>
            <option key={6} value={6}>6</option>
            <option key={7} value={7}>7</option>
            <option key={8} value={8}>8</option>
            <option key={9} value={9}>Default</option>
          </Input>
          {validationMessages['priority'] && (
            <FormText className='DangerFeedback'>
              {validationMessages['priority']}
            </FormText>
          )}
        </FormGroup>
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignPriorityForm.defaultProps = {
  isShowingTutorial:true,
  priority: 9
};

export default CampaignPriorityForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignPriorityForm.js